// this file is used for China logistics info

interface ShipperObj {
  name: string
  phone: string
}
// this shipper code mapping is for KDNiao
export const shipperCodeMapping: {
  [index: string]: ShipperObj
} = {
  ABGJ: {
    name: '澳邦国际',
    phone: '',
  },
  ADD: {
    name: '澳多多',
    phone: '',
  },
  AJ: {
    name: '安捷快递',
    phone: '',
  },
  ALKJWL: {
    name: '阿里跨境电商物流',
    phone: '',
  },
  AMAZON: {
    name: '亚马逊物流',
    phone: '',
  },
  ANE: {
    name: '安能物流',
    phone: '',
  },
  ANEKY: {
    name: '安能快运',
    phone: '',
  },
  ANNTO: {
    name: '安得物流',
    phone: '',
  },
  AOMENYZ: {
    name: '澳门邮政',
    phone: '',
  },
  AX: {
    name: '安迅物流',
    phone: '',
  },
  AXD: {
    name: '安鲜达',
    phone: '',
  },
  AYCA: {
    name: '澳邮专线',
    phone: '',
  },
  AYUS: {
    name: '安邮美国',
    phone: '',
  },
  BBFZY: {
    name: '帮帮发转运',
    phone: '',
  },
  BCTWL: {
    name: '百城通物流',
    phone: '',
  },
  BDT: {
    name: '八达通',
    phone: '',
  },
  BETWL: {
    name: '百腾物流',
    phone: '',
  },
  BFAY: {
    name: '八方安运',
    phone: '',
  },
  BFDF: {
    name: '百福东方',
    phone: '',
  },
  BHGJ: {
    name: '贝海国际',
    phone: '',
  },
  BJXKY: {
    name: '北极星快运',
    phone: '',
  },
  BNTWL: {
    name: '奔腾物流',
    phone: '',
  },
  BTWL: {
    name: '百世快运',
    phone: '',
  },
  CBO: {
    name: 'CBO钏博物流',
    phone: '',
  },
  CDSTKY: {
    name: '成都善途速运',
    phone: '',
  },
  CFWL: {
    name: '春风物流',
    phone: '',
  },
  CHTWL: {
    name: '诚通物流',
    phone: '',
  },
  CITY100: {
    name: '城市100',
    phone: '',
  },
  CJKD: {
    name: '城际快递',
    phone: '',
  },
  CND: {
    name: '承诺达',
    phone: '',
  },
  CNEX: {
    name: '佳吉快运',
    phone: '',
  },
  CNPEX: {
    name: 'CNPEX中邮快递',
    phone: '',
  },
  COE: {
    name: 'COE东方快递',
    phone: '',
  },
  CRAZY: {
    name: '疯狂快递',
    phone: '',
  },
  CSCY: {
    name: '长沙创一',
    phone: '',
  },
  CSTD: {
    name: '畅顺通达',
    phone: '',
  },
  CTG: {
    name: '联合运通',
    phone: '',
  },
  CXHY: {
    name: '传喜物流',
    phone: '',
  },
  DBL: {
    name: '德邦快递',
    phone: '',
  },
  DBLKY: {
    name: '德邦快运',
    phone: '',
  },
  DEKUN: {
    name: '德坤',
    phone: '',
  },
  DLG: {
    name: '到了港',
    phone: '',
  },
  DML: {
    name: '大马鹿',
    phone: '',
  },
  DNWL: {
    name: '丹鸟物流',
    phone: '',
  },
  DSWL: {
    name: 'D速物流',
    phone: '',
  },
  DTWL: {
    name: '大田物流',
    phone: '',
  },
  EMS: {
    name: 'EMS',
    phone: '11183',
  },
  EMS2: {
    name: 'EMS国内',
    phone: '',
  },
  EST365: {
    name: '东方汇',
    phone: '',
  },
  ETK: {
    name: 'E特快',
    phone: '',
  },
  EWE: {
    name: 'EWE',
    phone: '',
  },
  FASTGO: {
    name: '速派快递',
    phone: '',
  },
  FBKD: {
    name: '飞豹快递',
    phone: '',
  },
  FBOX: {
    name: '丰巢',
    phone: '',
  },
  FHKD: {
    name: '飞狐快递',
    phone: '',
  },
  FKD: {
    name: '飞康达',
    phone: '',
  },
  FRGYL: {
    name: '复融供应链',
    phone: '',
  },
  FT: {
    name: '丰通快运',
    phone: '',
  },
  FTD: {
    name: '富腾达',
    phone: '',
  },
  FYKD: {
    name: '凡宇货的',
    phone: '',
  },
  FYPS: {
    name: '飞远配送',
    phone: '',
  },
  FYSD: {
    name: '凡宇速递',
    phone: '',
  },
  GAI: {
    name: '迦递快递',
    phone: '',
  },
  GD: {
    name: '冠达',
    phone: '',
  },
  GDEMS: {
    name: '广东邮政',
    phone: '',
  },
  GDKD: {
    name: '冠达快递',
    phone: '',
  },
  GHX: {
    name: '挂号信',
    phone: '',
  },
  GKSD: {
    name: '港快速递',
    phone: '',
  },
  GSD: {
    name: '共速达',
    phone: '',
  },
  GTKD: {
    name: '广通速递',
    phone: '',
  },
  GTKY: {
    name: '高铁快运',
    phone: '',
  },
  GTONG: {
    name: '广通',
    phone: '',
  },
  GTSD: {
    name: '高铁速递',
    phone: '',
  },
  HBJH: {
    name: '河北建华',
    phone: '',
  },
  HF: {
    name: '汇丰物流',
    phone: '',
  },
  HFHW: {
    name: '合肥汇文',
    phone: '',
  },
  HGLL: {
    name: '黑狗冷链',
    phone: '',
  },
  HHKD: {
    name: '华航快递',
    phone: '',
  },
  HHTT: {
    name: '天天快递',
    phone: '',
  },
  HHWL: {
    name: '华翰物流',
    phone: '',
  },
  HISENSE: {
    name: '海信物流',
    phone: '',
  },
  HJWL: {
    name: '皇家物流',
    phone: '',
  },
  HLONGWL: {
    name: '辉隆物流',
    phone: '',
  },
  HLWL: {
    name: '恒路物流',
    phone: '',
  },
  HLYSD: {
    name: '好来运快递',
    phone: '',
  },
  HMSD: {
    name: '海盟速递',
    phone: '',
  },
  HOAU: {
    name: '天地华宇',
    phone: '',
  },
  HOTSCM: {
    name: '鸿桥供应链',
    phone: '',
  },
  HPTEX: {
    name: '海派通物流公司',
    phone: '',
  },
  hq568: {
    name: '华强物流',
    phone: '',
  },
  HQKD: {
    name: '华企快递',
    phone: '',
  },
  HQKY: {
    name: '华企快运',
    phone: '',
  },
  HQSY: {
    name: '环球速运',
    phone: '',
  },
  HRWL: {
    name: '韩润物流',
    phone: '',
  },
  HSSY: {
    name: '汇森速运',
    phone: '',
  },
  HSWL: {
    name: '昊盛物流',
    phone: '',
  },
  HTKD: {
    name: '青岛恒通快递',
    phone: '',
  },
  HTKY: {
    name: '百世快递',
    phone: '',
  },
  HTWL: {
    name: '鸿泰物流',
    phone: '',
  },
  HXLWL: {
    name: '华夏龙物流',
    phone: '',
  },
  HXWL: {
    name: '豪翔物流 ',
    phone: '',
  },
  HYH: {
    name: '货运皇物流',
    phone: '',
  },
  JAD: {
    name: '捷安达',
    phone: '',
  },
  JCEX: {
    name: '佳成国际',
    phone: '',
  },
  JD: {
    name: '京东快递',
    phone: '',
  },
  JDKY: {
    name: '京东快运',
    phone: '',
  },
  JDWL: {
    name: '金大物流',
    phone: '',
  },
  JGSD: {
    name: '京广速递',
    phone: '',
  },
  JGWL: {
    name: '景光物流',
    phone: '',
  },
  JIUYE: {
    name: '九曳供应链',
    phone: '',
  },
  JRHYWL: {
    name: '金润荷役物流',
    phone: '021-62133000',
  },
  JTKD: {
    name: '捷特快递',
    phone: '',
  },
  JTSD: {
    name: '极兔速递',
    phone: '',
  },
  JXD: {
    name: '急先达',
    phone: '',
  },
  JYKD: {
    name: '晋越快递',
    phone: '',
  },
  JYM: {
    name: '加运美',
    phone: '',
  },
  JYSY: {
    name: '精英速运',
    phone: '',
  },
  JYWL: {
    name: '佳怡物流',
    phone: '',
  },
  KBSY: {
    name: '快8速运',
    phone: '',
  },
  KFW: {
    name: '快服务',
    phone: '',
  },
  KLWL: {
    name: '康力物流',
    phone: '',
  },
  KSDWL: {
    name: '快速递物流',
    phone: '',
  },
  KTKD: {
    name: '快淘快递',
    phone: '',
  },
  KYDSD: {
    name: '快优达速递',
    phone: '',
  },
  KYSY: {
    name: '跨越速运',
    phone: '',
  },
  KYWL: {
    name: '跨越物流',
    phone: '',
  },
  LB: {
    name: '龙邦快递',
    phone: '',
  },
  LHKD: {
    name: '蓝弧快递',
    phone: '',
  },
  LHT: {
    name: '联昊通速递',
    phone: '',
  },
  LJD: {
    name: '乐捷递',
    phone: '',
  },
  LJS: {
    name: '立即送',
    phone: '',
  },
  MB: {
    name: '民邦快递',
    phone: '',
  },
  MD: {
    name: '迈达',
    phone: '',
  },
  MDM: {
    name: '门对门快递',
    phone: '',
  },
  MHKD: {
    name: '民航快递',
    phone: '',
  },
  MK: {
    name: '美快',
    phone: '',
  },
  MLWL: {
    name: '明亮物流',
    phone: '',
  },
  MRDY: {
    name: '迈隆递运',
    phone: '',
  },
  MSKD: {
    name: '闽盛快递',
    phone: '',
  },
  NEDA: {
    name: '能达速递',
    phone: '',
  },
  NFCM: {
    name: '南方传媒物流',
    phone: '',
  },
  NJSBWL: {
    name: '南京晟邦物流',
    phone: '',
  },
  PADTF: {
    name: '平安达腾飞快递',
    phone: '',
  },
  PANEX: {
    name: '泛捷快递',
    phone: '',
  },
  PCA: {
    name: 'PCA Express',
    phone: '',
  },
  PJ: {
    name: '品骏快递',
    phone: '',
  },
  PXWL: {
    name: '陪行物流',
    phone: '',
  },
  QCKD: {
    name: '全晨快递',
    phone: '',
  },
  QRT: {
    name: '全日通快递',
    phone: '',
  },
  QUICK: {
    name: '快客快递',
    phone: '',
  },
  QXT: {
    name: '全信通',
    phone: '',
  },
  QYZY: {
    name: '七曜中邮',
    phone: '',
  },
  RFD: {
    name: '如风达',
    phone: '',
  },
  RFEX: {
    name: '瑞丰速递',
    phone: '',
  },
  RLWL: {
    name: '日昱物流',
    phone: '',
  },
  RQ: {
    name: '荣庆物流',
    phone: '',
  },
  RRS: {
    name: '日日顺物流',
    phone: '',
  },
  SAD: {
    name: '赛澳递',
    phone: '',
  },
  SAWL: {
    name: '圣安物流',
    phone: '',
  },
  SCZPDS: {
    name: '速呈宅配',
    phone: '',
  },
  SDEZ: {
    name: '速递e站',
    phone: '',
  },
  SDHH: {
    name: '山东海红',
    phone: '',
  },
  SDWL: {
    name: '上大物流',
    phone: '',
  },
  SF: {
    name: '顺丰速运',
    phone: '95338',
  },
  SFGJ: {
    name: '顺丰国际',
    phone: '',
  },
  SFWL: {
    name: '盛丰物流',
    phone: '',
  },
  SHWL: {
    name: '盛辉物流',
    phone: '',
  },
  SJ: {
    name: '郑州速捷',
    phone: '',
  },
  SJWL: {
    name: '穗佳物流',
    phone: '',
  },
  SNWL: {
    name: '苏宁物流',
    phone: '',
  },
  SQWL: {
    name: '商桥物流',
    phone: '',
  },
  SS: {
    name: '闪送',
    phone: '',
  },
  ST: {
    name: '速通物流',
    phone: '',
  },
  STKD: {
    name: '盛通快递',
    phone: '',
  },
  STO: {
    name: '申通快递',
    phone: '',
  },
  STSD: {
    name: '三态速递',
    phone: '',
  },
  STWL: {
    name: '速腾快递',
    phone: '',
  },
  SUBIDA: {
    name: '速必达物流',
    phone: '',
  },
  SURE: {
    name: '速尔快递',
    phone: '',
  },
  SX: {
    name: '顺心捷达',
    phone: '',
  },
  SXHMJ: {
    name: '山西红马甲',
    phone: '',
  },
  SYJWDX: {
    name: '佳旺达物流',
    phone: '',
  },
  SYKD: {
    name: '世运快递',
    phone: '',
  },
  TAIWANYZ: {
    name: '台湾邮政',
    phone: '',
  },
  TDHY: {
    name: '华宇物流',
    phone: '',
  },
  THTX: {
    name: '通和天下',
    phone: '',
  },
  TJS: {
    name: '特急送',
    phone: '',
  },
  TLWL: {
    name: '腾林物流',
    phone: '',
  },
  TSSTO: {
    name: '唐山申通',
    phone: '',
  },
  TYWL: {
    name: '通用物流',
    phone: '',
  },
  UAPEX: {
    name: '全一快递',
    phone: '',
  },
  UBI: {
    name: 'UBI',
    phone: '',
  },
  UC: {
    name: '优速快递',
    phone: '',
  },
  UEQ: {
    name: 'UEQ Express,',
    phone: '',
  },
  WHTZX: {
    name: '武汉同舟行',
    phone: '',
  },
  WJK: {
    name: '万家康',
    phone: '',
  },
  WJWL: {
    name: '万家物流',
    phone: '',
  },
  WM: {
    name: '中粮我买网',
    phone: '',
  },
  WPE: {
    name: '维普恩',
    phone: '',
  },
  WTP: {
    name: '微特派',
    phone: '',
  },
  WTWL: {
    name: '温通物流',
    phone: '',
  },
  XBWL: {
    name: '新邦物流',
    phone: '',
  },
  XCWL: {
    name: '迅驰物流',
    phone: '',
  },
  XFEX: {
    name: '信丰物流',
    phone: '',
  },
  XIAOBI: {
    name: '晓毕物流',
    phone: '',
  },
  XJ: {
    name: '新杰物流',
    phone: '',
  },
  XLYT: {
    name: '祥龙运通',
    phone: '',
  },
  XYT: {
    name: '希优特',
    phone: '',
  },
  YADEX: {
    name: '源安达快递',
    phone: '',
  },
  YBJ: {
    name: '邮必佳',
    phone: '',
  },
  YBWL: {
    name: '优拜物流',
    phone: '',
  },
  YCSY: {
    name: '远成快运',
    phone: '',
  },
  YCWL: {
    name: '远成物流',
    phone: '',
  },
  YD: {
    name: '韵达速递',
    phone: '95546',
  },
  YDH: {
    name: '义达国际物流',
    phone: '',
  },
  YDKY: {
    name: '韵达快运',
    phone: '',
  },
  YDT: {
    name: '易达通',
    phone: '',
  },
  YF: {
    name: '耀飞快递',
    phone: '',
  },
  YFEX: {
    name: '越丰物流',
    phone: '',
  },
  YFHEX: {
    name: '原飞航物流',
    phone: '',
  },
  YFSD: {
    name: '亚风快递',
    phone: '',
  },
  YFSUYUN: {
    name: '驭丰速运',
    phone: '',
  },
  YJSD: {
    name: '银捷速递',
    phone: '',
  },
  YL: {
    name: '云路',
    phone: '',
  },
  YLJY: {
    name: '优联吉运',
    phone: '',
  },
  YLSY: {
    name: '亿领速运',
    phone: '',
  },
  YMDD: {
    name: '壹米滴答',
    phone: '',
  },
  YMWL: {
    name: '英脉物流',
    phone: '',
  },
  YOUCWL: {
    name: '邮畅快运',
    phone: '021-68029999',
  },
  YSDF: {
    name: '余氏东风',
    phone: '',
  },
  YSH: {
    name: '亿顺航',
    phone: '',
  },
  YSKY: {
    name: '音素快运',
    phone: '',
  },
  YTD: {
    name: '易通达',
    phone: '',
  },
  YTFH: {
    name: '一统飞鸿',
    phone: '',
  },
  YTKD: {
    name: '运通快递',
    phone: '',
  },
  YTO: {
    name: '圆通速递',
    phone: '',
  },
  YTOGJ: {
    name: '圆通国际',
    phone: '',
  },
  YUNDX: {
    name: '运东西网',
    phone: '',
  },
  YXKD: {
    name: '亿翔快递',
    phone: '',
  },
  YXWL: {
    name: '宇鑫物流',
    phone: '',
  },
  YZBK: {
    name: '邮政国内标快',
    phone: '',
  },
  YZGN: {
    name: '包裹/平邮/挂号信',
    phone: '',
  },
  YZPY: {
    name: '邮政快递包裹',
    phone: '',
  },
  YZT: {
    name: '一智通',
    phone: '',
  },
  YZTSY: {
    name: '一站通速运',
    phone: '',
  },
  ZENY: {
    name: '增益快递',
    phone: '',
  },
  ZHN: {
    name: '智汇鸟',
    phone: '',
  },
  ZHQKD: {
    name: '汇强快递',
    phone: '',
  },
  ZHWL: {
    name: '中骅物流',
    phone: '',
  },
  ZJS: {
    name: '宅急送',
    phone: '',
  },
  ZRSD: {
    name: '中睿速递',
    phone: '',
  },
  ZTE: {
    name: '众通快递',
    phone: '',
  },
  ZTKY: {
    name: '中铁快运',
    phone: '',
  },
  ZTO: {
    name: '中通快递',
    phone: '',
  },
  ZTOKY: {
    name: '中通快运',
    phone: '',
  },
  ZTWL: {
    name: '中铁物流',
    phone: '',
  },
  ZTWY: {
    name: '中天万运',
    phone: '',
  },
  ZWYSD: {
    name: '中外运速递',
    phone: '',
  },
  ZY_AZY: {
    name: '澳转运',
    phone: '',
  },
  ZY_BDA: {
    name: '八达网',
    phone: '',
  },
  ZY_BYECO: {
    name: '贝易购',
    phone: '',
  },
  ZY_CTM: {
    name: '赤兔马转运',
    phone: '',
  },
  ZY_CUL: {
    name: 'CUL中美速递',
    phone: '',
  },
  ZY_ETD: {
    name: 'ETD',
    phone: '',
  },
  ZY_FCKD: {
    name: '风驰快递',
    phone: '',
  },
  ZY_FLSD: {
    name: '风雷速递',
    phone: '',
  },
  ZY_HCYD: {
    name: '皓晨优递',
    phone: '',
  },
  ZY_HDB: {
    name: '海带宝',
    phone: '',
  },
  ZY_HFMZ: {
    name: '汇丰美中速递',
    phone: '',
  },
  ZY_HJSD: {
    name: '豪杰速递',
    phone: '',
  },
  ZY_HMKD: {
    name: '华美快递',
    phone: '',
  },
  ZY_HTAO: {
    name: '360hitao转运',
    phone: '',
  },
  ZY_HTCUN: {
    name: '海淘村',
    phone: '',
  },
  ZY_HTKE: {
    name: '365海淘客',
    phone: '',
  },
  ZY_HTONG: {
    name: '华通快运',
    phone: '',
  },
  ZY_HXKD: {
    name: '海星桥快递',
    phone: '',
  },
  ZY_HXSY: {
    name: '华兴速运',
    phone: '',
  },
  ZY_IHERB: {
    name: 'LogisticsY',
    phone: '',
  },
  ZY_LPZ: {
    name: '领跑者快递',
    phone: '',
  },
  ZY_LZWL: {
    name: '量子物流',
    phone: '',
  },
  ZY_MBZY: {
    name: '明邦转运',
    phone: '',
  },
  ZY_MJ: {
    name: '美嘉快递',
    phone: '',
  },
  ZY_MZ: {
    name: '168 美中快递',
    phone: '',
  },
  ZY_OEJ: {
    name: '欧e捷',
    phone: '',
  },
  ZY_OZF: {
    name: '欧洲疯',
    phone: '',
  },
  ZY_OZGO: {
    name: '欧洲GO',
    phone: '',
  },
  ZY_QMT: {
    name: '全美通',
    phone: '',
  },
  ZY_SCS: {
    name: 'SCS国际物流',
    phone: '',
  },
  ZY_SOHO: {
    name: 'SOHO苏豪国际',
    phone: '',
  },
  ZY_SONIC: {
    name: 'Sonic-Ex速递',
    phone: '',
  },
  ZY_TCM: {
    name: '通诚美中快递',
    phone: '',
  },
  ZY_TPAK: {
    name: 'TrakPak',
    phone: '',
  },
  ZY_TTHT: {
    name: '天天海淘',
    phone: '',
  },
  ZY_TZKD: {
    name: '天泽快递',
    phone: '',
  },
  ZY_XDKD: {
    name: '迅达快递',
    phone: '',
  },
  ZY_XDSY: {
    name: '信达速运',
    phone: '',
  },
  ZY_XGX: {
    name: '新干线快递',
    phone: '',
  },
  ZY_XJ: {
    name: '信捷转运',
    phone: '',
  },
  ZY_YGKD: {
    name: '优购快递',
    phone: '',
  },
  ZY_YJSD: {
    name: '友家速递(UCS)',
    phone: '',
  },
  ZY_YPW: {
    name: '云畔网',
    phone: '',
  },
  ZY_YSW: {
    name: '易送网',
    phone: '',
  },
  ZYE: {
    name: '众邮快递',
    phone: '',
  },
  ZYKD: {
    name: '中邮快递',
    phone: '',
  },
  ZYQS: {
    name: '中运全速',
    phone: '',
  },
  ZYWL: {
    name: '中邮物流',
    phone: '',
  },
}

export enum ORDER_TRACK_STATUS {
  CURRENTLY_NO_TRACE_DETAILS = '暂无轨迹信息',
  PICKED_UP = '已揽收',
  IN_TRANSIT = '在途中',
  ARRVIED_DESTINATION_CITY = '到达派件城市',
  IN_DELIVERY = '派件中',
  DELIVED_TO_DELIVERY_LOCKER = '已放入快递柜或驿站',
  DELIVERED = '已签收',
  DELIVERED_NORMALLY = '正常签收',
  DELIVERED_AFTER_ISSUE_RESOLVED = '派件异常后最终签收',
  DELIVERED_BY_COLLECTION = '代收签收',
  DELIVERED_BY_DELIVERY_LOCKER = '快递柜或驿站签收',
  ISUSE_HAPPENED = '问题件',
  NO_SHIPPER_INFORMATION = '发货无信息',
  NO_SIGN = '超时未签收',
  NO_UPDATION_AFTER_ISSUE_REPORTING = '超时未更新',
  REJECTED_BY_RECEIVER = '拒收(退件)',
  EXCEPTION_DELIVERY = '派件异常',
  RETURN_SIGNED = '退货签收',
  RETUREN_WITHOUT_SIGNATURE = '退货未签收',
  OVERTIME_IN_DELIVERY_LOCKER = '快递柜或驿站超时未取',
}

const traceStatusMapping: {
  [index: string]: ORDER_TRACK_STATUS
} = {
  '0': ORDER_TRACK_STATUS.CURRENTLY_NO_TRACE_DETAILS,
  '1': ORDER_TRACK_STATUS.PICKED_UP,
  '2': ORDER_TRACK_STATUS.IN_TRANSIT,
  '201': ORDER_TRACK_STATUS.ARRVIED_DESTINATION_CITY,
  '202': ORDER_TRACK_STATUS.IN_DELIVERY,
  '211': ORDER_TRACK_STATUS.DELIVED_TO_DELIVERY_LOCKER,
  '3': ORDER_TRACK_STATUS.DELIVERED,
  '301': ORDER_TRACK_STATUS.DELIVERED_NORMALLY,
  '302': ORDER_TRACK_STATUS.DELIVERED_AFTER_ISSUE_RESOLVED,
  '304': ORDER_TRACK_STATUS.DELIVERED_BY_COLLECTION,
  '311': ORDER_TRACK_STATUS.DELIVERED_BY_DELIVERY_LOCKER,
  '4': ORDER_TRACK_STATUS.ISUSE_HAPPENED,
  '401': ORDER_TRACK_STATUS.NO_SHIPPER_INFORMATION,
  '402': ORDER_TRACK_STATUS.NO_SIGN,
  '403': ORDER_TRACK_STATUS.NO_UPDATION_AFTER_ISSUE_REPORTING,
  '404': ORDER_TRACK_STATUS.REJECTED_BY_RECEIVER,
  '405': ORDER_TRACK_STATUS.EXCEPTION_DELIVERY,
  '406': ORDER_TRACK_STATUS.RETURN_SIGNED,
  '407': ORDER_TRACK_STATUS.RETUREN_WITHOUT_SIGNATURE,
  '412': ORDER_TRACK_STATUS.OVERTIME_IN_DELIVERY_LOCKER,
}

export const getTraceStatus = (statusCode: string): ORDER_TRACK_STATUS => {
  return traceStatusMapping[statusCode]
}

export const getShipperObj = (shipperCode?: string): ShipperObj => {
  if (!shipperCode || !shipperCodeMapping[shipperCode]) {
    return { name: '', phone: '' }
  }
  return shipperCodeMapping[shipperCode]
}

export const shipperCodeTrackingUrlMap = {
  rxshipping: 'JRHYWL',
  'yc-shipping': 'YOUCWL',
  ems: 'EMS',
  'sf-express': 'SF',
  'admin.hu-shipping': 'XIAOHU', // KDNiao doesn't support now
}

export const getShipperCodeByTrackingUrl = (trackingUrl?: string) => {
  if (!trackingUrl) {
    return ''
  }
  const key = Object.keys(shipperCodeTrackingUrlMap).find((key) =>
    trackingUrl.includes(key)
  )
  if (!key || !shipperCodeTrackingUrlMap[key]) {
    return ''
  }
  return shipperCodeTrackingUrlMap[key]
}

// this is expressCompany mapping, the key may be different from KDNiao mapping
export const expressCompanyMap = {
  YD: '韵达速递',
  EMS: 'EMS',
  GT: '国通',
}

export const getExpressComName = (expressCom?: string) => {
  if (!expressCom || !expressCompanyMap[expressCom]) {
    return expressCom
  }
  return expressCompanyMap[expressCom]
}

export const getShipperCodeByExpressCom = (expressCom?: string): string => {
  if (!expressCom || !shipperCodeMapping[expressCom]) {
    return ''
  }
  return expressCom
}

export const JPShippingPointDesc = {
  E066: 'Yamato Cool',
  E061: 'Nittsu',
  E062: '(Baraki)Nittsu',
  E063: 'Seino',
  E090: 'Nittsu',
  E091: 'Seino/Tonami',
  E020: 'Customer pickup',
}
